/**
 * Permission identifiers for the administrative procurement module — Issue #366.
 *
 * Mirrors apps/api/src/auth/services/module-catalog.ts so frontend gating
 * cannot diverge from backend RBAC.
 */
import { hasAnyPermission, hasPermission } from './crmPermissions';

export { hasAnyPermission, hasPermission };

export const ADMIN_PROCUREMENT_PERMISSIONS = {
  READ: 'admin_procurement:read',
  WRITE: 'admin_procurement:write',
  APPROVE: 'admin_procurement:approve',
  MANAGE: 'admin_procurement:manage',
  FINANCE: 'admin_procurement:finance',
} as const;

export function canSeeAdminProcurementMenu(
  permissions: readonly string[],
): boolean {
  return hasAnyPermission(permissions, [
    ADMIN_PROCUREMENT_PERMISSIONS.READ,
    ADMIN_PROCUREMENT_PERMISSIONS.WRITE,
  ]);
}

export function canManageAdminProcurement(
  permissions: readonly string[],
): boolean {
  return hasPermission(permissions, ADMIN_PROCUREMENT_PERMISSIONS.MANAGE);
}

export function canApproveAdminProcurement(
  permissions: readonly string[],
): boolean {
  return hasPermission(permissions, ADMIN_PROCUREMENT_PERMISSIONS.APPROVE);
}

export function canSeeAdminProcurementFinance(
  permissions: readonly string[],
): boolean {
  return hasPermission(permissions, ADMIN_PROCUREMENT_PERMISSIONS.FINANCE);
}
